import { DocumentToStoreState, DocumentToStoreModel, DocumentToStoreViewModel, CabinetModel, SchemaModel, TargetDocumentTypeSettingsModel, ExistingDocumentOption, PagesStoreMode } from '@/types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: DocumentToStoreState = {
  isLoading: true,
  isDirty: false,
  isReadonly: false,
  error: false,
  errorMessage: '',
  documentToStore: {} as DocumentToStoreModel,
  initialSchema: [] as SchemaModel[],
  initialDocumentDate: null,
  initialMultiValueReferences: [],
  documentToStoreView: {
    cabinets: [] as CabinetModel[],
    dynamicFormSchema: [] as SchemaModel[],
    targetDocumentTypeSettings: {} as TargetDocumentTypeSettingsModel
  } as DocumentToStoreViewModel,
  selectedSourceDocumentTypeId: 0,
  selectedTargetCabinetId: '',
  selectedPages: '1',
  extendingDocumentToStoreLock: false,
  existingDocumentId: 0,
  existingDocumentOption: ExistingDocumentOption.AddToDocument,
  keepPagesAfterStoring: false,
  pageViewedBeforeAddToExisting: 1,
  allPagesSelectedWithManualPageSelection: true,
  allPagesSelectedWithBatchSplitting: false,
  applyReferencesToNextDocumentEnabled: false,
  referencesForNextDocument: [] as SchemaModel[],
  multiValueReferencesForNextDocument: []
};

const namespaced: boolean = true;

export const documentToStore = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
